import React, { useEffect, useState } from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link } from "react-router-dom";
import fundnest2 from "../assets/logofn2.png";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DraftsIcon from "@mui/icons-material/Drafts";
import PhoneIcon from "@mui/icons-material/Phone";
import axios from "axios";
import baseUrl from "../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader";
import { useTranslation } from "react-i18next";

function Footer() {
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const fontLivic = "Livvic , sans-serif";
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const notify = (message) => toast.success(message);

  //  useEffect(() => {
  //     toast.dismiss()
  //  }, [toast])




  const handlesubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formdata = new FormData();
    formdata.append("email", email);

    try {
      const response = await axios.post(
        `${baseUrl}/news_letter_request.php`,
        formdata
      );
      // console.log(response);
      if (response.data.success === true) {
        setLoading(false);
        document.getElementById("subscribeEmail").value = "";
        notify("Subscribed Successfully");
        setTimeout(() => {
          navigate("/");
        }, 2500);
      }
      else {
        setLoading(false);
        toast.success(response.data.message);
        
      }
    } catch (err) { }
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "black",
          height: isXs ? "max-content" : "1080px",
          borderTopRightRadius: isXs ? "60px" : "0px",
          borderTopLeftRadius: isXs ? "60px" : "0px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
            // gap: "165px",
            padding: "30px 80px 10px 80px",
          }}
        >
          <div>
            {" "}
            <img height={50} src={fundnest2} alt="" />
          </div>
          <div
            style={{
              color: "white",
              fontSize: "40px",
              fontWeight: "600",
              display: isXs ? "flex" : "none",
            }}
          >
            {t('footer.heading')}
          </div>
          <div
            style={{
              color: "white",
              backgroundColor: "gray",
              borderRadius: "20px",
              padding: "10px 25px",
              fontFamily: fontLivic,
              display: isXs ? "flex" : "none",
            }}
          >
            {" "}
            <a
              style={{ color: "white", textDecoration: "none" }}
              href="/contact-us"
            >
              {t('footer.button')}
            </a>{" "}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "10px",
            padding: "0px 80px",

          }}
        >
          <div
            style={{ width: "100%", height: "1px", backgroundColor: "#ce7133" }}
          ></div>
        </div>
        <div
          style={{
            display: "flex",
            padding: isXs ? "20px 80px" : "10px 0px",
            flexDirection: isXs ? "" : "column-reverse",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: isXs ? "80px" : "10px",
              flexDirection: isXs ? "row" : "column",
              textAlign: isXs ? "" : "center",
              paddingTop: isXs ? "" : "40px",
              justifyContent: isXs ? "" : "space-around",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "7px",
                flexDirection: "column",
                paddingLeft: isXs ? "50px" : "0px",
                paddingTop: isXs ? "6px" : "",
              }}
            >
              <div
                div
                style={{
                  color: "white",
                  fontWeight: "500",
                  fontSize: isXs ? "18px" : "22px",
                  marginBottom: "0px",
                }}
              >
                {t('footer.pages.title')}
              </div>
              <div style={{ color: "white", fontSize: "14px" }}>
                {" "}
                <a style={{ textDecoration: "none", color: "white" }} href="/">
                  {" "}
                  {t('footer.pages.links', { returnObjects: true })[0]}
                </a>
              </div>
              {/* <div style={{color:'white' ,fontSize:'14px', fontFamily:fontLivic}}> <a style={{textDecoration:'none', color:'white'}} href="/services">All services</a></div> */}
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/about-us"
                >
                  {t('footer.pages.links', { returnObjects: true })[1]}
                </a>
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/privacy-policy"
                >
                  {t('footer.pages.links', { returnObjects: true })[2]}
                </a>{" "}
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/terms-conditions"
                >
                  {t('footer.pages.links', { returnObjects: true })[3]}
                </a>
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/contact-us"
                >
                  {t('footer.pages.links', { returnObjects: true })[4]}
                </a>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: "7px",
                flexDirection: "column",
                paddingTop: isXs ? "6px" : "",
              }}
            >
              <div
                div
                style={{
                  color: "white",
                  fontWeight: "500",
                  fontSize: isXs ? "18px" : "22px",
                  marginBottom: "0px",
                }}
              >
                {t('footer.services.title')}
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/services/it-staffing"
                >
                  {t('footer.services.items', { returnObjects: true })[0]}
                </a>
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/services/strategic-consulting"
                >
                  {t('footer.services.items', { returnObjects: true })[1]}
                </a>
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/services/design-development"
                >
                  {t('footer.services.items', { returnObjects: true })[2]}
                </a>
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/services/digital-marketing"
                >
                  {t('footer.services.items', { returnObjects: true })[3]}
                </a>
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/services/cloud-solutions"
                >
                  {t('footer.services.items', { returnObjects: true })[4]}
                </a>
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              >
                {" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="/services/database-security"
                >
                  {t('footer.services.items', { returnObjects: true })[5]}
                </a>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: "7px",
                flexDirection: "column",
                paddingTop: isXs ? "6px" : "",
              }}
            >
              <div
                style={{
                  color: "white",
                  fontWeight: "500",
                  fontSize: isXs ? "18px" : "22px",
                  marginBottom: "0px",
                }}
              >
                {t('footer.contactInfo.title')}
              </div>
              <div
                style={{
                  display: "flex",
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                  justifyContent: isXs ? "" : "center",
                }}
              >
                <LocationOnIcon style={{ marginRight: "8px" }} />
                <div>
                  {t('footer.contactInfo.address', { returnObjects: true })[0]} <br />
                  {t('footer.contactInfo.address', { returnObjects: true })[1]} <br />
                  {t('footer.contactInfo.address', { returnObjects: true })[2]}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                  justifyContent: isXs ? "" : "center",
                }}
              >
                <DraftsIcon style={{ marginRight: "8px" }} />
                <a href="mailto:connect@fundnest.in" style={{ textDecoration: "none", color: "white" }}>connect@fundnest.in</a>
              </div>
              <div
                style={{
                  display: "flex",
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                  justifyContent: isXs ? "" : "center",
                }}
              >
                <PhoneIcon style={{ marginRight: "8px" }} />
                <div>+91 XXXXXXXXXX</div>
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              ></div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              ></div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              ></div>
              <div
                style={{
                  color: "white",
                  fontSize: "14px",
                  fontFamily: fontLivic,
                }}
              ></div>
            </div>
          </div>
          <div
            style={{
              color: "white",
              marginLeft: isXs ? "35px" : "20px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              textAlign: isXs ? "" : "center",
            }}
          >
            <div
              style={{
                fontSize: "30px", fontWeight: "600", maxWidth: "70%", marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              {t('footer.newsletter.title')}
            </div>
            <form onSubmit={handlesubmit}>
              <div
                style={{
                  position: "relative",
                  width: "max-content",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    backgroundColor: "#000000",
                    fontFamily: fontLivic,
                    border: "1px solid white",
                    borderRadius: "20px",
                    height: "40px",
                    width: "300px",
                    paddingLeft: "15px",
                    color: "white",
                  }}
                  type="text"
                  placeholder="Enter Email Address"
                  id="subscribeEmail"
                />{" "}
                <button
                  type="submit"
                  style={{
                    position: "absolute",
                    top: "2px",
                    right: "2px",
                    minHeight: "90%",
                    border: "1px solid black",
                    borderRadius: "20px",
                    padding: "5px 25px",
                    backgroundColor: "white",
                    color: "black",
                    fontFamily: fontLivic,
                    cursor: "pointer",
                  }}
                >
                  {loading ? <Loader /> : t('footer.newsletter.buttonText')}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "30px",
            padding: isXs ? "0px 80px" : "0px 30px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "0.7px",
              backgroundColor: "#ce7133",
              marginTop: isXs ? "" : "20px",
            }}
          ></div>
        </div>

        <div
          style={{
            fontSize: "14px",
            color: "white",
            height: "40px",
            display: "flex",
            padding: "30px 80px",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: isXs ? "row" : "column",
            gap: "20px",
            // marginTop: isXs ? "" : "30px",

          }}
        >
          <div
            style={{
              display: "flex",
              gap: isXs ? "15px" : "6px",
              flexDirection: isXs ? "row" : "column",

            }}
          >
            <div style={{ fontFamily: fontLivic }}>
              Copyright © {currentYear} Fundnest{" "}
            </div>
            <div
              style={{
                display: "inline-block",
                textDecoration: "none",
                fontFamily: fontLivic,
              }}
            >
              {" "}
              Powered by{" "}
              <a
                href="https://www.infomagine.in"
                target="_blank"
                style={{ color: "#fff", textDecoration: "none" }}
              >
                Infomagine
              </a>
            </div>
          </div>

          <div style={{ display: "flex", gap: "20px" }}>
            <div>
              <FacebookIcon />
            </div>
            <div>
              <InstagramIcon />
            </div>
            <div>
              <TwitterIcon />
            </div>
            <div>
              <LinkedInIcon />
            </div>
          </div>
        </div>
      </div>

      {/* <ToastContainer
        position="top-right"
        autoClose={5000} // This controls the auto-dismiss time
        hideProgressBar={false}
        newestOnTop={true}
        closeButton
      /> */}
    </>
  );
}

export default Footer;
